module.exports = __webpack_public_path__ + "static/media/couple.e1a8bf96.png";


//////////////////
// WEBPACK FOOTER
// ./src/App/pages/Home/pages/Main/assets/couple.png
// module id = 550
// module chunks = 0